









































































import { Component, Vue } from "vue-property-decorator";
import HNotification from "@/components/base/h-notification/index.vue";

const notifications = [
  {
    title: "Lorem ipsum dolor",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint, repudiandae?",
    time: "4 min",
    outdated: false
  }
];

const outdatedNotifications = [
  {
    title: "Lorem ipsum dolor",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint, repudiandae?",
    time: "4 min",
    outdated: false
  },
  {
    title: "Outdated Notification",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint, repudiandae?",
    time: "4 min",
    outdated: true
  },
  {
    title: "Lorem ipsum dolor",
    desc:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint, repudiandae?",
    time: "4 min",
    outdated: false
  }
];

@Component({
  name: "NotificationSimple",
  components: {
    HNotification
  }
})
export default class NotificationSimple extends Vue {
  private get notifications() {
    return [...new Array(100)].reduce(items => {
      items.push(...notifications);

      return items;
    }, []);
  }

  private get outdatedNotifications() {
    return [...new Array(33)].reduce(items => {
      items.push(...outdatedNotifications);

      return items;
    }, []);
  }

  private getClickData(data, index) {
    alert(
      ` index: ${index} \n title: ${data.title} \n description ${data.desc}`
    );
  }
}
